module.exports = "https://coursera_assets.s3.amazonaws.com/images/e4ffceb5453f49bb27a8a2f8f455ed2d.jpg";